let notificationSystem = null

function setNotificationSystem(ns) {
  notificationSystem = ns
}

/**
 *
 * See https://github.com/igorprado/react-notification-system#creating-a-notification
 * level: success, error, warning and info
 * timeout in seconds
 * children: overrides the message (doesnt it?)
 */
function notify(message, { title = null, level = "info", timeout = 5, children = null } = {}) {
  if (!notificationSystem) {
    console.error("Notification system was not set by index.js")
  }
  else {
    notificationSystem.addNotification({
      message,
      level,
      autoDismiss: timeout,
      children,
      position: "br",
      title,
    })
  }
}

const NotificationBypass = {
  notify,
  setNotificationSystem
}

export default NotificationBypass
